import { render, staticRenderFns } from "./PaseListaSection.vue?vue&type=template&id=15c51024"
import script from "./PaseListaSection.vue?vue&type=script&lang=js"
export * from "./PaseListaSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports